import {createContext} from "react";

export const DataPageContext = createContext({});
